module.exports = __webpack_public_path__ + "static/media/directora-23.6ebf1c13.jpg";